import React, { Fragment, useEffect, useState, dispatch } from 'react';
import { connect } from "react-redux";
import { getChildDevice, getDeviceUsagebyId, offboardDeviceById } from '../../action/report';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Moment from 'react-moment';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { getACDeviceStatusKeyMap, normalizeTimestamp } from '../../utils/general';
import customConfig from '../../config';

const useStyles = makeStyles({
  container: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
    marginTop: '20px'
  },
  activeTab: {
    border: '1px solid #bdbdbd',
    backgroundColor: 'gray',
    textTransform: 'capitalize',
    color: 'white',
    minWidth: '120px'
  },
  nonActiveTab: {
    border: 'none',
    backgroundColor: 'none',
    textTransform: 'capitalize',
    color: 'black',
    minWidth: '120px'
  },
  tabsWrapper: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    marginBottom: '20px'
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    marginTop: '1.5rem',
  },
  linkBlock: {
    width: '100%',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '1rem',
    backgroundColor: '#f5f5f5'
  },
  expandedRow: {
    backgroundColor: '#f9f9f9',
    padding: '10px',
    borderTop: '1px solid #ccc'
  },
  childRow :{
    border: '1px solid #ccc',
    padding: '8px',
    textAlign: 'center'
  }
});

const VRFDeviceDetails = ({ deviceId, getChildDevice, getDeviceUsagebyId, offboardDeviceById, setAlert, onChildCountChange }) => {
  const classes = useStyles();
  const [childDevicesByAdapter, setChildDevicesByAdapter] = useState({});
  const [selectedAdapterIndex, setSelectedAdapterIndex] = useState(0);
  const [adapterIds, setAdapterIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedDeviceId, setExpandedDeviceId] = useState(null);
  const [deviceUsageData, setDeviceUsageData] = useState(null);
  const [selectedChildDevices, setSelectedChildDevices] = useState({});
  const [offboardingLinks, setOffboardingLinks] = useState({});

  const fetchAndProcessChildDevices = async () => {
    if (!deviceId) return;

    setLoading(true);
    getChildDevice(deviceId)
      .then((res) => {
        const grouped = {};
        let totalChildren = res.length;
        if (typeof onChildCountChange === "function") {
          onChildCountChange(totalChildren);
        }

        res.forEach((device) => {
          const { czAdapterId, linkNumber, iduNumber } = device.ieeeAddressParts;

          if (!grouped[czAdapterId]) {
            grouped[czAdapterId] = {};
          }
          if (!grouped[czAdapterId][linkNumber]) {
            grouped[czAdapterId][linkNumber] = [];
          }

          grouped[czAdapterId][linkNumber].push({
            iduNumber,
            ...device
          });
        });

        const ids = Object.keys(grouped).map(Number).sort((a, b) => a - b);
        setChildDevicesByAdapter(grouped);
        setAdapterIds(ids);
        setSelectedAdapterIndex(0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching child devices:", err);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchAndProcessChildDevices();
  }, [deviceId]);

  const handleToggleRow = (deviceId) => {
    if (expandedDeviceId === deviceId) {
      setExpandedDeviceId(null);
      setDeviceUsageData(null);
    } else {
      getDeviceUsagebyId(deviceId)
        .then((data) => {
          setDeviceUsageData(data);
          setExpandedDeviceId(deviceId);
        })
        .catch(err => {
          console.error("Error fetching usage:", err);
        });
    }
  };
  
  const selectedAdapterId = adapterIds[selectedAdapterIndex];

  const handleDeviceSelect = (czAdapterId, link, deviceId) => {
  setSelectedChildDevices((prev) => {
    const updated = { ...prev };
    if (!updated[czAdapterId]) updated[czAdapterId] = {};
    if (!updated[czAdapterId][link]) updated[czAdapterId][link] = [];

    const index = updated[czAdapterId][link].indexOf(deviceId);
    if (index !== -1) {
      updated[czAdapterId][link] = updated[czAdapterId][link].filter(id => id !== deviceId);
    } else {
      updated[czAdapterId][link] = [...updated[czAdapterId][link], deviceId];
    }

    return updated;
  });
};


  const handleSelectAll = (czAdapterId, link) => {
  setSelectedChildDevices((prev) => {
    const updated = { ...prev };
    const allDeviceIds = childDevicesByAdapter[czAdapterId][link].map((d) => d.deviceId);
    const currentlySelected = updated[czAdapterId]?.[link] || [];

    if (currentlySelected.length === allDeviceIds.length) {
      if (updated[czAdapterId]) updated[czAdapterId][link] = [];
    } else {
      if (!updated[czAdapterId]) updated[czAdapterId] = {};
      updated[czAdapterId][link] = allDeviceIds;
    }

    return updated;
  });
};


  const handleOffboardDevices = async (czAdapterId, link) => {

  if(!window.confirm(customConfig.confirmOffboard)){
    return;
  };
  
  const devicesToOffboard = selectedChildDevices[czAdapterId]?.[link];
  if (!devicesToOffboard || devicesToOffboard.length === 0) return;

  setOffboardingLinks((prev) => ({
    ...prev,
    [`${czAdapterId}-${link}`]: true
  }));

  try {
    
    let totalSuccess = 0;

    for (const deviceId of devicesToOffboard) {
      try {
        await offboardDeviceById(deviceId);
        totalSuccess++;
      } catch (error) {
        console.log(`Failed to offboard device ${deviceId}`, error);
      }
    }

    if (totalSuccess > 0) {
      setAlert("Device(s) Offboarded Successfully.", "success");
      window.scrollTo(0, 0);
    } else {
      setAlert("Failed to Offboard device(s).", "danger");
    }

    setOffboardingLinks((prev) => ({
      ...prev,
      [`${czAdapterId}-${link}`]: false
    }));

    setSelectedChildDevices((prev) => {
      const updated = { ...prev };
      if (updated[czAdapterId]) updated[czAdapterId][link] = [];
      return updated;
    });

    await fetchAndProcessChildDevices();
  } catch (error) {
    setAlert("Failed to Offboard device(s)", "danger");
    setOffboardingLinks((prev) => ({
      ...prev,
      [`${czAdapterId}-${link}`]: false
    }));
  }
};




  const DeviceUsageDetail = ({deviceUsageData}) => {
    if (!deviceUsageData){
      return (
      <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'red',
        fontSize: '1.2rem',
        fontWeight: '500',
        padding: '1rem',
        boxSizing: 'border-box'
      }}>
        {customConfig.noDataMsg}
      </div>
    );
    };
  
    const entries = Object.entries(deviceUsageData);
    const mid = Math.ceil(entries.length / 2);
    const left = entries.slice(0, mid);
    const right = entries.slice(mid);
  
    const renderColumn = (data) => (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {data.map(([key, value]) => (
          <div key={key} className="unique-box mb-15">
            <label className="title d-inline min-180">{getACDeviceStatusKeyMap(key)}</label>
            <div className="device-info d-inline">
              {['ts', 'connectedTime', 'updatedTime', 'nextUpdate'].includes(key)
                ? <Moment format="MMMM Do YYYY, h:mm:ss a" date={normalizeTimestamp(value)} />
                : String(value) || '-'}
            </div>
          </div>
        ))}
      </div>
    );
  
    return (
      <>
        {renderColumn(left)}
        {renderColumn(right)}
      </>
    );
  };
  
  const ChildDeviceRow = ({ child, onToggle, link, isExpanded, deviceUsageData }) => (
    <>
      <tr>
        <td className={classes.childRow} >{child.iduNumber}</td>
        <td className={classes.childRow} >{child.deviceId}</td>
        <td className={classes.childRow} >{child.modelNumber}</td>
        <td className={classes.childRow} >{child.productSerialNumber}</td>
        <td className={classes.childRow} >
          <IconButton size="small" onClick={() => onToggle(child.deviceId)}>
            <VisibilityIcon />
          </IconButton>
        </td>
        <td className={classes.childRow}>
          <Checkbox
            color="primary"
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selectedChildDevices[selectedAdapterId]?.[link]?.includes(child.deviceId) || false}
            onClick={() => handleDeviceSelect(selectedAdapterId, link, child.deviceId)}

          />
        </td>
      </tr>
      {isExpanded && (
        <tr>
          <td colSpan={6} className={classes.expandedRow}>
            <div style={{
              padding: '16px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              backgroundColor: '#eef6fb'
            }}>
              <h4 style={{fontWeight: 'bold', marginBottom: '16px', color: '#1b4f72', textAlign: 'center', fontSize: '16px', color: '#0c5460' }}>
                Device Status of DeviceId: {child.deviceId}
              </h4>
              <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '40px',
                  fontSize: '14px'
              }}>
                <DeviceUsageDetail deviceUsageData={deviceUsageData} />
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
  


  return (
    <div className={classes.container}>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
          <CircularProgress />
        </div>
      ) : !adapterIds.length ? (
        <div>No adapters found for Device ID: {deviceId}</div>
      ) : (
        <>
          <div className={classes.tabsWrapper}>
            <Tabs
              value={selectedAdapterIndex}
              onChange={(e, newIndex) => setSelectedAdapterIndex(newIndex)}
              TabIndicatorProps={{ style: { backgroundColor: '#bdbdbd' } }}
              variant="scrollable"
              scrollButtons="auto"
            >
              {adapterIds.map((adapterId, index) => (
                <Tab
                  key={adapterId}
                  label={`CZ Adapter ${adapterId}`}
                  className={selectedAdapterIndex === index ? classes.activeTab : classes.nonActiveTab}
                />
              ))}
            </Tabs>
          </div>

          <div className={classes.linkContainer}>
            {Object.keys(childDevicesByAdapter[selectedAdapterId] || {}).map((link) => (
              <div key={link} className={classes.linkBlock}>
                <div
                  style={{
                    display: 'flex',              
                    justifyContent: 'space-between', 
                    alignItems: 'center',         
                    backgroundColor: '#d1ecf1',
                    padding: '5px 12px',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    fontSize: '16px',
                    color: '#0c5460'
                  }}
                >
                  <span>Link {link}</span>
                  {childDevicesByAdapter[selectedAdapterId]?.[link]?.length > 0 && (
                    <div style={{ display: 'inline-block', alignItems: 'center' }}>
                      <Checkbox
                        color="primary"
                        checked={
                          selectedChildDevices[selectedAdapterId]?.[link]?.length ===
                          childDevicesByAdapter[selectedAdapterId][link].length
                        }
                        onClick={() => handleSelectAll(selectedAdapterId, link)}

                      />
                      <span>
                        {selectedChildDevices[selectedAdapterId]?.[link]?.length === childDevicesByAdapter[selectedAdapterId][link].length
                          ? 'Unselect All'
                          : 'Select All'}
                      </span>
                    </div>
                  )}
                </div>

                {childDevicesByAdapter[selectedAdapterId]?.[link]?.length > 0 ? (
                  <div style={{ width: '100%', overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <th className={classes.childRow}>IDU Number</th>
                          <th className={classes.childRow}>DeviceId</th>
                          <th className={classes.childRow}>Model Number</th>
                          <th className={classes.childRow}>Product Serial Number</th>
                          <th className={classes.childRow}>Device Status</th>
                          <th className={classes.childRow}>Offboard</th>
                        </tr>
                      </thead>
                      <tbody>
                        {childDevicesByAdapter[selectedAdapterId][link]
                          .sort((a, b) => a.iduNumber - b.iduNumber)
                          .map((child) => (
                            <ChildDeviceRow
                              key={child.deviceId}
                              child={child}
                              link={link}
                              onToggle={handleToggleRow}
                              isExpanded={expandedDeviceId === child.deviceId}
                              deviceUsageData={deviceUsageData}
                            />
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>No devices on this link.</p>
                )}
                {selectedChildDevices[selectedAdapterId]?.[link]?.length > 0 && (
                  <div style={{ textAlign: 'right', marginTop: '10px' }}>
                    <button
                      className="btn btn-style-3 orange-bg sm font-400 min-140 mqtt_btn"
                      disabled={
                        !selectedChildDevices[selectedAdapterId]?.[link] ||
                        selectedChildDevices[selectedAdapterId][link].length === 0 ||
                        offboardingLinks[`${selectedAdapterId}-${link}`]
                      }
                      onClick={() => handleOffboardDevices(selectedAdapterId, link)}
                    >
                      {offboardingLinks[`${selectedAdapterId}-${link}`] ? (
                        <CircularProgress size="1.5em" style={{ color: 'white', marginTop: '5px' }} />
                      ) : (
                        "Offboard Selected Device"
                      )}
                    </button>
                  </div>
                )}

              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getChildDevice: (deviceId) => dispatch(getChildDevice(deviceId)),
  getDeviceUsagebyId: (deviceId) => dispatch(getDeviceUsagebyId(deviceId)),
  offboardDeviceById: (deviceId) => dispatch(offboardDeviceById(deviceId)),
});

export default connect(null, mapDispatchToProps)(VRFDeviceDetails);
